"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var composition_api_1 = require("@vue/composition-api");
exports.default = composition_api_1.defineComponent({
    name: 'WokDataGridActions',
    setup: function () {
        var cfg = composition_api_1.inject('wokDataGridConfiguration');
        var columns = composition_api_1.computed(function () { return cfg === null || cfg === void 0 ? void 0 : cfg.columns; });
        var locale = composition_api_1.computed(function () { return cfg === null || cfg === void 0 ? void 0 : cfg.locale; });
        return {
            columns: columns,
            locale: locale
        };
    }
});
